import React, { useEffect } from 'react';
import { useLocation, useNavigate, BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import LoginForm from './components/LoginForm';
import RegisterForm from './components/RegisterForm';
import Dashboard from './pages/Dashboard';
import AlunosPorPolo from './pages/AlunosPorPolo';
import CursosPorPolo from './pages/CursosPorPolo';
import AtualizacaoCadastral from './pages/AtualizacaoCadastral';
import AnexoPDF from './pages/AnexarPDF';
import Ofertas from './pages/Ofertas';
import RelatorioIngressosPage from './pages/RelatorioIngressosPage';
import RelatorioCursosPage from './pages/RelatorioCursosPage';
import RelatorioMaisOfertadosPage from './pages/RelatorioMaisOfertadosPage';
import RelatorioStatusCursosPage from './pages/RelatorioStatusCursosPage';
import ProtectedRoute from './components/ProtectedRoute'; // Importe o componente ProtectedRoute
import { isTokenExpired } from './utils/tokenUtils'; // Importa a função
import './styles/main.scss';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';

const App = () => {
  const navigate = useNavigate();
  const currentLocation = useLocation(); // Renomeando a variável

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (isTokenExpired(token) && currentLocation.pathname !== '/register') {
      // Se o token estiver expirado, redireciona para a página de login
      localStorage.removeItem('token'); // Remove o token expirado
      navigate('/'); // Redireciona para a página de login
    }
  }, [navigate]);

  return (
    <Routes>
      {/* Rota para a página de Login */}
      <Route path="/" element={<LoginForm /> } />

      {/* Rota para a página de Registro */}
      <Route path="/register" element={<RegisterForm />} />

      {/* Rota para o Dashboard e suas páginas internas */}
      <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />

      {/* Rota para a página de Alunos por Polo */}
      <Route path="/alunos-polo" element={<ProtectedRoute><AlunosPorPolo /></ProtectedRoute>} />

      {/* Rota para a página de Cursos por Polo */}
      <Route path="/cursos-polo" element={<ProtectedRoute><CursosPorPolo /></ProtectedRoute>} />

      {/* Rota para a página de Atualização Cadastral */}
      <Route path="/atualizacao-cadastral" element={<ProtectedRoute><AtualizacaoCadastral /></ProtectedRoute>} />
      
      {/* Rota para a página de Anexos */}
      <Route path="/anexos" element={<ProtectedRoute><AnexoPDF /></ProtectedRoute>} />
      
      {/* Rota para a página de Ofertas */}
      <Route path="/ofertas" element={<ProtectedRoute><Ofertas /></ProtectedRoute>} />
      
      {/* Rota para a página de Relatórios de Ingressos */}
      <Route path="/relatorio-ingressos" element={<ProtectedRoute><RelatorioIngressosPage /></ProtectedRoute>} />

      {/* Rota para a página de Relatórios de Cursos */}
      <Route path="/relatorio-cursos" element={<ProtectedRoute><RelatorioCursosPage /></ProtectedRoute>} />

      {/* Rota para a página de Relatórios de Mais Ofertados */}
      <Route path="/relatorio-mais-ofertados" element={<ProtectedRoute><RelatorioMaisOfertadosPage /></ProtectedRoute>} />

      {/* Rota para a página de Relatórios de Status de Cursos */}
      <Route path="/relatorio-status-cursos" element={<ProtectedRoute><RelatorioStatusCursosPage /></ProtectedRoute>} />
    </Routes>
  );
};

const AppWrapper = () => (
  <Router>
    <App />
  </Router>
);

export default AppWrapper;
